import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { AxiosError } from 'axios'

import { Dialog, snackbar } from 'components'
import CustomTextField from 'components/CustomTextField'
import { useCheckFormErrors, useApiCall } from 'hooks'
import { CustomCheckbox } from 'components/CustomCheckbox'
import { CustomFormControlLabel } from 'components/CustomFormControlLabel'

import { UserPoll, CreateUserPollPayload, CreateUserPollResponse } from '../../types'
import { createUserPoll } from '../../api'
import { constants } from '../../constansts'

const rules = {
  question: [
    {
      validate: (value: string) => !value || value.length <= 254,
      message: 'No puede superar los 254 caracteres',
    },
  ],
}

const requiredFields = ['question', 'active']

interface CreateUserPollDialogProps {
  handleClose: () => void
  onDone: (newUserPoll: UserPoll) => void
}

const CreateUserPollDialog: React.FC<CreateUserPollDialogProps> = ({ handleClose, onDone }) => {
  const [question, setQuestion] = useState('')
  const [active] = useState(false)
  const [defaultDashboard, setDefaultDashboard] = useState(false)

  const [createUserPollApi, isLoading] = useApiCall<CreateUserPollPayload, CreateUserPollResponse>(
    createUserPoll,
  )

  const handleQuestionChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    setQuestion(e.target.value)
  }

  const handleChangeDefaultDashboard: React.ChangeEventHandler<HTMLInputElement> = () => {
    setDefaultDashboard(!defaultDashboard)
  }

  const fields = { question, active }
  const { hasErrors, isAnyFieldEmpty, errors } = useCheckFormErrors(fields, rules, requiredFields)
  const isSubmitDisabled = hasErrors || isAnyFieldEmpty || isLoading

  const onCreateUserPoll = async () => {
    if (!question) return
    const userPoll = {
      question,
      active,
      defaultDashboard,
    }
    try {
      const { userPoll: newUserPoll } = await createUserPollApi(userPoll)
      onDone(newUserPoll)
    } catch (err) {
      if ((err as AxiosError).message === 'DEFAULT_DASHBOARD_ERROR') {
        snackbar.show('Ya existe una pregunta por defecto para el dashboard')
        return
      }
      console.error(err)
      snackbar.show(`No se pudo crear ${constants.TEST_NAME}. Intente de nuevo.`)
    }
  }

  return (
    <Dialog
      title={`Nuevo ${constants.TEST_NAME}`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Crear"
      okButtonProps={{ disabled: isSubmitDisabled }}
      onAccept={onCreateUserPoll}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomTextField
            label="Pregunta"
            value={question}
            fullWidth
            onChange={handleQuestionChange}
            disabled={isLoading}
            multiline
            maxLength={254}
            error={errors.question.hasError}
            helperText={errors.question.message}
          />
        </Grid>
        <Grid item xs={11}>
          <CustomFormControlLabel
            control={
              <CustomCheckbox onChange={handleChangeDefaultDashboard} checked={defaultDashboard} />
            }
            label="Default Dashboard"
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { CreateUserPollDialog }
